import kemtai from './kemtai/locales';
import mixpanel from './mixpanel/locales';

export default {
  en: {
    ...kemtai.en,
    ...mixpanel.en,
  },
  es: {
    ...kemtai.es,
    ...mixpanel.es,
  },
  de: {
    ...kemtai.de,
    ...mixpanel.de,
  },
  cs: {
    ...kemtai.cs,
    ...mixpanel.cs,
  },
  ja: {
    ...kemtai.ja,
    ...mixpanel.ja,
  },
  sk: {
    ...kemtai.sk,
    ...mixpanel.sk,
  },
  it: {
    ...kemtai.it,
    ...mixpanel.it,
  },
  fr: {
    ...kemtai.fr,
    ...mixpanel.fr,
  },
  pl: {
    ...kemtai.pl,
    ...mixpanel.pl,
  },
  pt: {
    ...kemtai.pt,
    ...mixpanel.pt,
  },
  'pt-br': {
    ...kemtai['pt-br'],
    ...mixpanel['pt-br'],
  },
  'zh-hk': {
    ...kemtai['zh-hk'],
    ...mixpanel['zh-hk'],
  },
};
